import { render, staticRenderFns } from "./CategorizedListRecordSelector.vue?vue&type=template&id=58fc3762&scoped=true"
import script from "./CategorizedListRecordSelector.vue?vue&type=script&lang=js"
export * from "./CategorizedListRecordSelector.vue?vue&type=script&lang=js"
import style0 from "./CategorizedListRecordSelector.vue?vue&type=style&index=0&id=58fc3762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc3762",
  null
  
)

export default component.exports